import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=954387fe&"
import script from "./ProductsScript.js?vue&type=script&lang=js&"
export * from "./ProductsScript.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports